export default __webpack_public_path__ + "static/media/step-two-1.bc581941.jpg";